export default __webpack_public_path__ + "static/media/emoji1.4c4c9505.svg";